// RoiInvestorBenefits.tsx
/* eslint-disable @next/next/no-img-element */
import * as React from "react";
import { Box, Paper, Stack, Typography, Grid } from "@mui/material";
import CtaButton from "../buttonWithArrow"; // or replace with your own CTA button
import Heading from "../heading";
import Image from "next/image";

const MAX_W = 1300;     // section content cap
const IMG_W = 1200;      // max width for the illustration

export default function RoiInvestorBenefits({ data, onClick, buttonMarginTop, headingBottom }) {
    const { title, subtitle, button, image, showSparkle, bgcolor, width } = data;
    return (
        <Box
            component="section"
            sx={{
                py: { xs: 8, md: 4 },
                px: { xs: 2, sm: 3 },
                bgcolor: bgcolor ?? "#f7f9f9",
            }}
        >
            {/* Header */}
            <Heading title={title} subtitle={subtitle} lineClamp={showSparkle ? 2 : 1} showSparkle={showSparkle ? "/img/investments/Sparkle.svg" : undefined} mb={headingBottom ? headingBottom : 7} />

            {/* Illustration + floating pills */}
            <Box sx={{ maxWidth: MAX_W, mx: "auto" }}>
                <Box
                    sx={{
                        position: "relative",
                        width: "100%",
                        maxWidth: IMG_W,
                        mx: "auto",
                        display: "flex",
                        justifyContent: "center"
                    }}
                >
                    <Box
                        component="img"
                        src={image?.src} // <-- change to your image path
                        alt={image?.alt}
                        loading="lazy"
                        style={{ width: width ?? "100%", height: "auto", display: "block" }}
                    />
                </Box>

                {/* CTA */}
                {
                    button &&
                    <Stack alignItems="center" sx={{ mt: buttonMarginTop ? buttonMarginTop : { xs: 4, md: 5 } }}>
                        {
                            button?.endIconSrc ?
                                <CtaButton
                                    label={button?.text} onClick={(e) => onClick(e)}
                                    endIconSrc="/img/header/VectorDown.svg"
                                />
                                : <CtaButton label={button?.text} onClick={(e) => onClick(e)} />
                        }
                    </Stack>
                }
            </Box>
        </Box>
    );
}
